import { useState, useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import config from '../config';
import styled from 'styled-components';
import { Skeleton } from './Skeleton';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  width: 100%;
`;

const Button = styled.button`

`;

const ErrorMessage = styled.p`
  color: #dc3545;
  padding: 1rem;
`;

export const ViewSecret: FC = () => {
  const { token, isAuthenticated, login } = useAuth();
  const { secretId } = useParams();

  if (!isAuthenticated) {
    login(secretId);
  }

  const [retrievedSecret, setRetrievedSecret] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const getSecret = async (id: string) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${config.apiUrl}/secrets/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        login(secretId);
        return;
      }

      if (response.status === 404) {
        setError('Secret not found or already viewed');
        return;
      }

      const { secret } = await response.json();
      setRetrievedSecret(secret);
    } catch (err) {
      setError('Failed to retrieve secret');
    } finally {
      setIsLoading(false);
    }
  };


  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(retrievedSecret);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
    }
  };

  useEffect(() => {
    if (secretId) {
      getSecret(secretId);
    }
  }, [secretId, isAuthenticated]);

  if (error) {
    return <Container><ErrorMessage>{error}</ErrorMessage></Container>;
  }

  if (isLoading) {
    return (
      <Container>
        <Skeleton.Text height="100px" />
        <Skeleton.Button />
      </Container>
    );
  }

  return (
    <Container>
      {retrievedSecret && (
        <div>
          <p className="retrieved-secret">{retrievedSecret}</p>
          <Button onClick={copyToClipboard}>
            Copy Content
          </Button>
          <div className="copy-success">
            {copySuccess && <span style={{ marginLeft: '8px' }}>{copySuccess}</span>}
          </div>
        </div>
      )}
    </Container>
  );
};
